import { render, staticRenderFns } from "./subCategoryDetail.vue?vue&type=template&id=3a9c382c"
import script from "./subCategoryDetail.vue?vue&type=script&lang=js"
export * from "./subCategoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports